import React from 'react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from './ui/dropdown-menu';
import { Button } from './ui/button';
import { Plus, Type, Columns3, StickyNote } from 'lucide-react';

// Einheitliches "+"-Menü für Sektionen (Zeile / Text-Zeile / Spalte / …)
function AddMenu({ onAddRow, onAddText, onAddColumn, label }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="no-print" data-testid="add-menu-button">
          <Plus className="h-4 w-4" />
          {label ? <span className="ml-1">{label}</span> : null}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-44">
        {onAddRow && (
          <DropdownMenuItem onClick={onAddRow} data-testid="add-row-item">
            <Plus className="h-4 w-4 mr-2" />
            Zeile
          </DropdownMenuItem>
        )}
        {onAddText && (
          <DropdownMenuItem onClick={onAddText} data-testid="add-text-item">
            <Type className="h-4 w-4 mr-2" />
            Text-Zeile
          </DropdownMenuItem>
        )}
        {onAddColumn && (
          <DropdownMenuItem onClick={onAddColumn} data-testid="add-column-item">
            <Columns3 className="h-4 w-4 mr-2" />
            Spalte
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default AddMenu;
